import { Wrench, Phone, MessageCircle, Mail, MapPin, Instagram, Facebook } from 'lucide-react'

const quickLinks = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Contato', href: '#formulario' },
]

const serviceLinks = [
  'Motorista Particular',
  'Freteiro',
  'Reparos Elétricos',
  'Reparos Hidráulicos',
  'Montagem de Móveis',
  'Pinturas em Geral',
]

const FooterSection = () => {
  return (
    <footer data-testid="footer" className="bg-[#030F22] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 lg:pt-20 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-14">

          {/* Brand column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 bg-[#F2B300] flex items-center justify-center flex-shrink-0">
                <Wrench size={18} className="text-[#062B63]" />
              </div>
              <div>
                <div className="text-white font-bold text-[11px] leading-tight tracking-[0.12em] uppercase font-outfit">
                  MARIDO DE ALUGUEL
                </div>
                <div className="text-white/35 text-[9px] leading-tight tracking-[0.12em] uppercase font-inter">
                  Reparos e Manutenção
                </div>
              </div>
            </div>

            <p className="text-white/45 text-sm leading-relaxed mb-6 max-w-[240px]">
              Soluções práticas para o seu dia a dia. Serviços com qualidade, confiança e preço justo para sua casa ou empresa.
            </p>

            <div className="flex items-center gap-2.5">
              <a
                href="https://wa.me/5547988114676"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
                className="w-8 h-8 bg-white/8 border border-white/10 hover:bg-[#F2B300] hover:border-[#F2B300] flex items-center justify-center transition-all duration-200"
              >
                <MessageCircle size={14} />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-8 h-8 bg-white/8 border border-white/10 hover:bg-[#F2B300] hover:border-[#F2B300] flex items-center justify-center transition-all duration-200"
              >
                <Instagram size={14} />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                data-testid="footer-facebook"
                className="w-8 h-8 bg-white/8 border border-white/10 hover:bg-[#F2B300] hover:border-[#F2B300] flex items-center justify-center transition-all duration-200"
              >
                <Facebook size={14} />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-bold text-[11px] uppercase tracking-[0.15em] mb-5 font-outfit">
              Links rápidos
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/45 text-sm hover:text-[#F2B300] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-[11px] uppercase tracking-[0.15em] mb-5 font-outfit">
              Nossos serviços
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map((s) => (
                <li key={s}>
                  <a
                    href="#servicos"
                    className="text-white/45 text-sm hover:text-[#F2B300] transition-colors"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-[11px] uppercase tracking-[0.15em] mb-5 font-outfit">
              Contato
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+5547988114676"
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-white/45 text-sm hover:text-white transition-colors"
                >
                  <Phone size={14} className="flex-shrink-0 mt-0.5 text-[#F2B300]" />
                  (47) 98811-4676
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/5547988114676"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-white/45 text-sm hover:text-white transition-colors"
                >
                  <MessageCircle size={14} className="flex-shrink-0 mt-0.5 text-[#F2B300]" />
                  (47) 98811-4676
                </a>
              </li>
              <li>
                <a
                  href="mailto:contato@maridodealuguel.com.br"
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-white/45 text-sm hover:text-white transition-colors break-all"
                >
                  <Mail size={14} className="flex-shrink-0 mt-0.5 text-[#F2B300]" />
                  contato@maridodealuguel.com.br
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/45 text-sm">
                <MapPin size={14} className="flex-shrink-0 mt-0.5 text-[#F2B300]" />
                Balneário Camboriú e região
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/25 text-xs">
            © 2024 Marido de Aluguel. Todos os direitos reservados.
          </p>
          <p className="text-white/25 text-xs">
            Desenvolvido com <span className="text-[#F2B300]">♥</span> para você.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default FooterSection
